import {PayloadAction, createSlice} from "@reduxjs/toolkit";

export type INotificationBullets = {
  newBroadcastMessages: number,
  newMessages: number,
  newHomeFeed: number,
  newNotifications: number
}

const initialState: INotificationBullets = {
  newBroadcastMessages: 0,
  newHomeFeed: 0,
  newMessages: 0,
  newNotifications: 0,
};

export const NotificationBulletSlice = createSlice({
  name: "notification-bullet",
  initialState,
  reducers: {
    setNavigationBullets: (state, action: PayloadAction<INotificationBullets>) => {
      state.newBroadcastMessages = action.payload.newBroadcastMessages;
      state.newHomeFeed = action.payload.newHomeFeed;
      state.newMessages = action.payload.newMessages;
      state.newNotifications = action.payload.newNotifications;
    },
    setBulletsOnMarkAllRead : (state) => {
      state.newNotifications = 0;
    },
  },
});

export const {setNavigationBullets , setBulletsOnMarkAllRead} =
  NotificationBulletSlice.actions;
export default NotificationBulletSlice.reducer;
